var exports = {
  "u": "xfd349460--67ba11--toggle-btn",
  "q": "xfd349460--67ba11--toggle-btn--close",
};

module.exports = exports;
